
import { loadSectionTranslations } from '../../i18n-setup'
import { createNamespacedHelpers } from 'vuex'
import { ACTION_TOGGLE_POPUP_ID } from '@store/actions/ui'
import SghRecovery from '../my-account/components/recovery/sgh-recovery.vue'
import {KEYBOARD_NAVIGATION_CLASS} from '@libs/utils/const'
const { mapActions: mapActionsUi,mapGetters:mapGettersUi } = createNamespacedHelpers('ui')
export default {
  name: 'SghPopup',
  components:{
    SghRecovery,
  },
  props: {
    parentClose: {
      type: String,
      default: '',
    },
    translate: {
      type: String,
      default: '',
    },
    popupCheckout: {
      type: String,
      default: '',
    },
    popupExclusive: {
      type: String,
      default: '',
    },
    popupDecorative: {
      type: String,
      default: '',
    },
    isFindAStore: {
      type: Boolean,
      default: false,
    },
    popupId: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default() {
        return {
          posclose: 'right-top',
          size: 'md',
          css: '',
        }
      },
    },
    sitekey: {
      type: String,
      default: '',
    },
    confirmMail: {
      type: Boolean,
      default: false,
    },
    readerAlertMsg: {
      type: String,
      default: 'dialog',
    },
    checkKeyboardNavigation: {
      type: Boolean,
      default: true,
    },
    defineInstanceInGlobal: {
      type: Boolean,
      default: false,
    },
    isChanelOverlimit: {
      type: Boolean,
      default: false,
    },
    chanelTemplate: {
      type: Object,
      default() {
        return {
          title: 'Sorry, something went wrong!',
          description: 'Chanel items overlimit',
          btnText: 'Review Cart',
        }
      },
    },
  },
  data() {
    return {
      areLabelsLoaded: false,
      isOpen: this.open,
      setResetFlow: false,
      backLogin: false,
      isNotify: false,
      mail: '',
      params: {},
      configurator: () => {},
    }
  },
  computed: {
    isPopupOpen() {
      return (this.isOpen || this.updatedOpenProp) && this.areLabelsLoaded
    },
    isFocusTrapActive() {
      return this.isPopupOpen && (this.isKeyboardNavigation || !this.checkKeyboardNavigation)
    },
    isKeyboardNavigation() {
      return document.querySelector('body').classList
        ? document.querySelector('body').classList.contains(KEYBOARD_NAVIGATION_CLASS)
        : false
    },
    popupIdClass() {
      if (this.popupId === 'loyaltyLoginRegister') {
        return 'loyaltyLoginRegister'
      } else if (this.popupId === 'loyaltyInfoPopUp') {
        return 'loyaltyInfoPopUp'
      } else if (this.popupId === 'payOverTimePopup') {
        return 'payOverTimePopup'
      } else if (this.popupId === 'paymentPopupKlarna') {
        return 'paymentPopupKlarna'
      } else if (this.popupId === 'paymentPopupPaypal') {
        return 'paymentPopupPaypal'
      } else if (this.popupId === 'rxItemToCartDisabledPopup') {
        return 'rxItemToCartDisabledPopup'
      } else if (this.popupId === 'rxManualPrescription') {
        return 'rxManualPrescription'
      }else {
        return ''
      }
    },
    updatedOpenProp() {
      return this.open
    },
  },
  mounted() {
    this.getConfig()
    this.translate !== ''
      ? loadSectionTranslations(this.translate).then(() => (this.areLabelsLoaded = true))
      : (this.areLabelsLoaded = true)

    this.$root.$on('beginResetFlow', () => {
      this.setResetFlow = true
      this.backLogin = false
    })

    this.$root.$on('goLogin', () => {
      this.backLogin = true
      this.isNotify = false
    })

    this.$root.$on('isSuccess', mail => {
      this.mail = mail
      this.isNotify = true
    })

    if(this.defineInstanceInGlobal) {
      if(!window.sghPopups) {
        window.sghPopups = {}
      }
      window.sghPopups[this.popupId] = this
    }

    document.addEventListener('keydown', (e) => {
      if (e?.key === 'Escape') {
        this.toggleOpen()
      }
    })
  },
  methods: {
    ...mapActionsUi({
      togglePopup: ACTION_TOGGLE_POPUP_ID,
    }),
    getConfig() {
      switch (this.config.size) {
        case 'min':
          this.configurator = {
            widthMobile: 'w-full',
          }
          break
        case 'xs':
          this.configurator = {
            widthDesktop: 'max-w-500rem',
            widthMobile: 'max-w-36rem',
            margin: this.config.margin ? this.config.margin : '',
          }
          break
        case 'xxs':
          this.configurator = {
            widthDesktop: 'w-fit',
            widthMobile: 'w-fit',
            margin: this.config.margin ? this.config.margin : '',
          }
          break
        case 'md':
          this.configurator = {
            widthDesktop: 'w-45%',
            widthMobile: 'max-w-36rem',
            margin: this.config.margin ? this.config.margin : 'md:mt-2.7rem',
          }
          break
      }
      this.configurator = {
        ...this.configurator,
        posclose: `${this.config.posclose.includes('right-top') ? 'right-0' : 'left-0'} ${
          this.config.posclose === 'right-top-big' ? 'mr-0 right-0 big-icon' : 'mr-1.6rem'
        } mt-4`,
      }
    },
    toggleOpen() {
      this.isOpen = false
      this.togglePopup({
        popupId: this.popupId,
        open: false,
      })
      if(this.parentClose) {
        this.$parent[this.parentClose] = false
      }
      this.setResetFlow = false
      this.backLogin = false
      this.isNotify = false
      this.$emit('closePopup',this.popupId)
      this.$root.$emit('sghPopupTypeClosed', this.popupId)
      this.isFindAStore ? this.$root.$emit('openNewPopupFindAStore', true) : null
      this.popupExclusive && document.querySelector('body').classList
        ? document.querySelector('body').classList.remove('noscroll', 'isExclusiveOpen')
        : null
      document.querySelector('body').classList
        ? document.querySelector('body').classList.remove('noscroll')
        : null
    },
    importData(params) {
      this.params = params
    },
    close(){
      this.togglePopup({
        popupId: this.popupId,
        open: false,
      })
    },
  },
}
